<template>
    <layout>
        <v-row 
            align="center"
            justify="center"
        > 
            <v-card
                class="pa-6" 
                width="500"
            >
                <v-row>
                    <p class="font-weight-light">
                        I agree with and will abide by all the School's policies,
                        regulations and rules which are detailed in the School's Handbook. I will ensure my child 
                        conforms to the standards of work and conduct expected, both within
                        and outside the confines of the school while attending {{ schoolName }}.
                        Additionaly, I will make every effort to have my child uphold the Ministry's 
                        School Code of conduct.
                    </p>
                    <v-checkbox
                        label="I Agree"
                        v-model="agree"
                        @change="updateStore"
                        color="primary"                        
                    ></v-checkbox>
                </v-row>

                <v-row 
                    align="center"
                    justify="center"
                    v-show="printButton"                   
                >
                    <v-col
                        cols="12"
                        class="pl-0"                        
                    >
                        <v-btn
                            dark
                            color="primary"
                            @click="dialogSubmit = true"
                            block
                        >                            
                            Submit Application
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>
        </v-row>

        <v-dialog
            v-model="dialogSubmit"
            width="400"
            persistent
        >
            <v-card>
                <v-card-title class="text-center">
                    <span class="mx-auto">Application Successfully Submitted</span>
                </v-card-title>
                <v-card-text>
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                        <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
                        <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
                    </svg>
                </v-card-text>

                <v-card-actions class="flex-column">
                        <v-btn
                            color="primary"
                            outlined
                            @click="generatePDF"
                            class="text-capitalize"
                            block
                        >
                            Click to Generate Application Form
                        </v-btn>
                        <div 
                            class="mt-0 text-caption font-weight-light"                        
                        >8 1/2 x 14 (Legal) Sheet Required</div>
                        <v-btn 
                            depressed 
                            block 
                            class="my-4" 
                            @click="dialogSubmit = false"
                        >
                            Close
                        </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <v-dialog
            v-model="registrationForm" 
            transition="dialog-bottom-transition"
            persistent
        >   
            <v-card
                v-if="registrationForm"
                height="90vh"
            >
                <v-toolbar
                    dark
                    color="primary"
                    height="30"
                >
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        small
                        dark
                        @click="closeRegistrationForm"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <iframe ref="pdf" style="width:100%; height:80vh" frameBorder="0" :src="src"></iframe>  

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        outlined
                        @click="closeRegistrationForm"
                        class="text-capitalize"
                    >
                        Close Registration Form
                    </v-btn>
                </v-card-actions>              
            </v-card>
                            
        </v-dialog>
           
    </layout>
</template>

<script>
import Layout from './layouts/Registration';
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    name: 'Complete',
    components: {
        Layout,
    },
    mounted: function(){
        this.initialize();
        // this.setRegistrationForm();
    },

    data: () => ({
        printButton: true,        
        studentRecord: {},
        agree: false,
        registrationForm: false,
        iframe: null,        
        src: "",
        dialogSubmit: false,
    }),

    watch: {
       //
    },

    computed: {
        ...mapGetters({
            getStudentRecord: 'auth/getStudentRecord',
            termsAndConditions: 'form/getTermsAndConditions',
            student: 'auth/getUser',
            schoolName: 'form/getSchoolName',
        }),

        getAgree(){
            if(this.termsAndConditions == 1) return true;
            return false;
        },

    },
    methods: {
        ...mapMutations({
            setOverlay: 'auth/setOverlay',
            setDataFiles: 'form/setStudentDataFiles',
            setTermsAndCondtions: 'form/setTermsAndConditions',
        }),

        ...mapActions({
            getDataFiles: 'form/getStudentDataFiles',
            postDataFiles: 'form/postStudentDataFiles',
            getRegistrationForm: 'auth/getRegistrationForm'
        }),

        async initialize (){ 
            this.setOverlay(true);
            try {
                const { data } = await this.getDataFiles();
                this.setStudentRecord(data);
                this.setAgree();
                this.setRegistrationForm();                
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }
            this.setOverlay(false);
        },

        async updateStore(){
            if(this.agree){
                this.studentRecord.agree_terms_conditions = 1;
            }
            else{
                this.studentRecord.agree_terms_conditions = 0;
            }
            try {
                this.setDataFiles(this.studentRecord);
                const response = await this.postDataFiles();
                console.log(response);
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }            
            
            
        },

        setStudentRecord(data){
            this.studentRecord = {...data}            
        },

        setAgree(){
            //console.log(this.getAgree);
            if(this.studentRecord.agree_terms_conditions == 1) this.agree = true;
            else this.agree = false;
        },

        generatePDF(){
           this.registrationForm = true;
           //console.log(this.registrationFormURI);
        },

        setRegistrationForm(){
            // console.log(this.studentRecord);
            this.src = process.env.VUE_APP_API_URI + '/api/registration-form/new/' + this.studentRecord.student_id;
            //console.log(this.registrationFormURI)            
        },
        closeRegistrationForm(){            
            this.registrationForm = false
        },
    }
}
</script>

<style scoped>
svg {
        width: 100px;
        display: block;
        margin: 40px auto 0;
    }

    .path {
        stroke-dasharray: 1000;
        stroke-dashoffset: 0;
    }

    .path.circle {
        -webkit-animation: dash 0.9s ease-in-out;
        animation: dash 0.9s ease-in-out;
    }

    .path.line {
        stroke-dashoffset: 1000;
        -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
        animation: dash 0.9s 0.35s ease-in-out forwards;
    }

    .path.check {
        stroke-dashoffset: -100;
        -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
        animation: dash-check 0.9s 0.35s ease-in-out forwards;
    }

    @-webkit-keyframes dash {
        0% {
            stroke-dashoffset: 1000;
        }
        100% {
            stroke-dashoffset: 0;
        }
    }

    @keyframes dash {
        0% {
            stroke-dashoffset: 1000;
        }
        100% {
            stroke-dashoffset: 0;
        }
    }

    @-webkit-keyframes dash-check {
        0% {
            stroke-dashoffset: -100;
        }
        100% {
            stroke-dashoffset: 900;
        }
    }

    @keyframes dash-check {
        0% {
            stroke-dashoffset: -100;
        }
        100% {
            stroke-dashoffset: 900;
        }
    }
    </style>